// @flow
import FeeReport from './FeeReport'
export default () => ({
  path: 'fee-report',
  element: <FeeReport />,
})
